module.exports = __webpack_public_path__ + "static/media/icono_direccion.411e49ec.svg";